<form class="grid w-full grid-cols-3 gap-4" [formGroup]="selectDateForm" >
  <div class="flex flex-col items-start mt-6">
    <app-date-picker
      formControlName="startDateCtrl"
      id="Create-Ballot-Start-Date"
      name="startDate"
      label="Start Date"
      placeholder="Select date"
      [minDate]="minStartDate"
      [maxDate]="maxStartDate"
      [errorMessage]="errorMessage"
      >
    </app-date-picker>
  </div>

  <div class="flex flex-col items-center w-full mt-5">
    <div class="flex flex-col w-1/2 items-right">
      <app-select id="duration" label="Duration" [options]="durationOptions" formControlName="durationCtrl"></app-select>
    </div>
  </div>
  <div class="flex flex-col items-end mt-6">
    <app-date-picker
      #createBallotEndDate
      formControlName="endDateCtrl"
      id="Create-Ballot-End-Date"
      name="endDate"
      label="End Date"
      placeholder="Select date"
      [minDate]="minEndDate"
      >
    </app-date-picker>
  </div>
</form>


